import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-534bffe7"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody D-Flex" }
const _hoisted_4 = { class: "CookiesRow F-C2" }
const _hoisted_5 = {
  key: 0,
  class: "CookiesRow F1_25em W-100"
}
const _hoisted_6 = { class: "M-Auto color3" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1))
const _hoisted_9 = { class: "M-Auto F-Bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!

  return (_openBlock(), _createElementBlock("div", {
    id: 'CookiesDialog_' + _ctx.DialogIndex,
    class: "CookiesDialogdBody"
  }, [
    (_ctx.Saving)
      ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.FixedData.Icon)
        ? (_openBlock(), _createBlock(_component_CookiesIcon, {
            key: 0,
            ID: _ctx.FixedData.Icon,
            style: {"width":"3.5em","height":"3.5em","padding":"0.5em"},
            class: "M-Auto Shadow1"
          }, null, 8, ["ID"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.FixedData.Text)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, [
                  _createElementVNode("span", {
                    innerHTML: _ctx.FixedData.Text
                  }, null, 8, _hoisted_7)
                ]),
                _hoisted_8
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
              style: _normalizeStyle('background: ' + _ctx.Theme.Shade3),
              class: "F-Bold CookiesButton DialogFooterButton"
            }, _toDisplayString(_ctx.Translate('Cancel')), 5),
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.Confirm())),
              class: _normalizeClass(["F-Bold CookiesButton DialogFooterButton BGMain", _ctx.FixedData.ButtonClass]),
              style: _normalizeStyle(_ctx.FixedData.ButtonStyle)
            }, _toDisplayString(_ctx.FixedData.ButtonText ? _ctx.FixedData.ButtonText : _ctx.Translate('Confirm')), 7)
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}